var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"background"}),_c('a-spin',{staticStyle:{"z-index":"1"},attrs:{"size":"large","tip":"Loading..."}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }